import { type JSX, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { usePatternsStore } from '~/stores/patternsStore';

import { PatternSidebar } from './components/PatternSidebar';

export function PatternsLayout(): JSX.Element {
  const { pathname } = useLocation();
  const setLastPatternsPath = usePatternsStore(s => s.setLastPatternsPath);

  // Track last visited path within /patterns for cross-section navigation
  useEffect(() => {
    if (pathname !== '/patterns') {
      setLastPatternsPath(pathname);
    }
  }, [pathname, setLastPatternsPath]);

  return (
    <div className="flex h-full min-h-0 overflow-hidden">
      <PatternSidebar />
      <main className="flex-1 min-w-0 overflow-y-auto overscroll-contain">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
